import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'nullAsWhatever',
    standalone: false
})
export class NullAsWhateverPipe implements PipeTransform {
  transform(value: any, replacer: any = '-'): any {
    if (value === undefined || value === null || value.toString().length === 0) {
      return replacer
    }
    return value
  }
}
